import React from 'react';
import { useParams } from 'react-router-dom';

const CasesByStatus = () => {
  const { status } = useParams();
  
  const statusLabels = {
    'new': 'Nowe',
    'in-progress': 'W realizacji',
    'assigned': 'Przekazane',
    'done': 'Zakończone'
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-xl">Sprawy - {statusLabels[status] || status}</h2>
      </div>
      <div className="card-body">
        <p className="text-gray-600">Lista spraw ze statusem {status} - do implementacji</p>
      </div>
    </div>
  );
};

export default CasesByStatus;
